import { createTheme } from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"
import Layout from "components/Layout"
import LoadingSkeleton from "components/shared/LoadingSkeleton"
import useLanguage from "hooks/useLanguage"
import useLocalStorage from "hooks/useLocalStorage"
import usePageLocalStorageContext from "hooks/usePageLocalStorageContext"
import useUserContext from "hooks/useUserContext"
import { FC, Suspense, useMemo } from "react"
import { Outlet } from "react-router-dom"
import theme from "theme"
import { APP } from "utils/constants"
import { PAGES_LOCAL_STORAGE } from "utils/constants/localStorage.constants"

import { PageLocalStorageContextProvider } from "./contexts/PageLocalStorageContext/PageLocalStorageContextProvider"

const AppLayout: FC = () => {
  const { languageObject } = useLanguage()
  const themeWithLocale = useMemo(
    () => createTheme(theme, languageObject.materialCode),
    [languageObject.materialCode]
  )
  const { clearPageLocalStorage } = usePageLocalStorageContext()

  const { userUniqueId } = useUserContext()
  const { value: appVersion, handleValueChange: handleAppVersionChange } =
    useLocalStorage(PAGES_LOCAL_STORAGE.APP_VERSION, APP.NO_VERSION)

  if (appVersion !== APP.VERSION) {
    clearPageLocalStorage()
    handleAppVersionChange(APP.VERSION)
  }

  return (
    <PageLocalStorageContextProvider userId={userUniqueId}>
      <ThemeProvider theme={themeWithLocale}>
        <Layout>
          <Suspense fallback={<LoadingSkeleton />}>
            <Outlet />
          </Suspense>
        </Layout>
      </ThemeProvider>
    </PageLocalStorageContextProvider>
  )
}

export default AppLayout
